import { render, staticRenderFns } from "./quienes.vue?vue&type=template&id=07a8b6dc&"
import script from "./quienes.vue?vue&type=script&lang=js&"
export * from "./quienes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports